import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/vue-query';
import { MaybeRefOrGetter } from '@vueuse/core';

import { fetchSignerInfo } from '../services';

export const signerQueryKeys = createQueryKeys('signer', {
  show: (signatureRequestKey: MaybeRefOrGetter<string>) => [{ signatureRequestKey }],
});

export function useFetchSigner(signatureRequestKey: MaybeRefOrGetter<string>) {
  const { data, ...result } = useQuery({
    queryKey: signerQueryKeys.show(signatureRequestKey).queryKey,
    queryFn: () => fetchSignerInfo(toValue(signatureRequestKey)),
    initialData: undefined,
  });

  return {
    ...result,
    signer: data,
  };
}
